import { render } from "./UserDetail.vue?vue&type=template&id=1ecac79a&scoped=true"
import script from "./UserDetail.vue?vue&type=script&lang=js"
export * from "./UserDetail.vue?vue&type=script&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=1ecac79a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3966428095/src/eelam-tv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecac79a"]])

export default __exports__